import { useSyncExternalStore } from 'react'
import { isStaleBundle, subscribeStaleBundle } from '@/lib/staleBundle'

/**
 * The one "new version" prompt (STALE-BUNDLE-M1), mounted once in App outside
 * RouteErrorBoundary so it survives the boundary's fallback.
 *
 * A bottom card, not a modal: when the failure came from a background import,
 * the screen underneath still works, and whatever a crew member was typing
 * stays there until they choose to reload.
 */
export function StaleBundlePrompt() {
  const stale = useSyncExternalStore(subscribeStaleBundle, isStaleBundle)
  if (!stale) return null

  return (
    <div
      role="alert"
      className="fixed inset-x-0 bottom-0 z-50 flex justify-center p-4 pb-[max(1rem,env(safe-area-inset-bottom))]"
    >
      <div className="flex w-full max-w-md items-center gap-3 rounded-xl border border-gray-200 bg-white p-4 shadow-lg">
        <p className="flex-1 text-sm font-semibold text-gray-900">
          A new version of the app is available
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white"
        >
          Reload
        </button>
      </div>
    </div>
  )
}
